export default __webpack_public_path__ + "static/media/bannerBackground.459457c4.svg";